// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {Markerset} from "@models";
import {SimMarkersetService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-bookmarks-chip-input",
	templateUrl: "./sim-bookmarks-chip-input.component.html",
	styleUrls: ["./sim-bookmarks-chip-input.component.scss"],
	standalone: false,
})
export class SimBookmarksChipInputComponent {
	@Input() bookmarkFc: FormArray<FormControl<Markerset>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleBookmarkSets = false;

	optionSelected = output<Markerset>();

	autoCompleteData: VMAutoCompleteNormal<Markerset>[] = [];

	constructor(private _simMarkerSetService: SimMarkersetService) {}

	reloadAutoCompleteData(searchString: string) {
		this._simMarkerSetService.listMarkersets(searchString, "Name", true, 0, 20).then((markersets) => {
			this.autoCompleteData = markersets.data.map((m) => ({
				displayName: m.name,
				value: m,
			}));
		});
	}
}
